/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { Icon } from '@fitinsur/components'

import * as S from './styles';

import { generalHandler } from '../index';
import { limitsHandler } from '../../limits/index';

function renderSectionExtraButtons({
  partySectionName,
  sectionState,
  setSectionState,
  index,
  questions,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  setFieldValue,
  ignoreRemove,
  onRemove = null,
}) {

  return (
    <>
      {!ignoreRemove && index !== 0 &&
        <S.IconButton style={{ marginBottom: '15px' }} onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const newArray = sectionState.filter((v, i) => i !== index);
          setSectionState(newArray);
          setQuestionnaireAnswersToDelete([
            ...questionnaireAnswersToDelete,
            ...questions.map(
              question => question.idQuestionnaireAnswers
            ).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
          ])

          if (onRemove) {
            onRemove(newArray);
          }

        }}>
          <Icon name="trash" style={{ margin: 0 }} />
        </S.IconButton>
      }
      {index === sectionState.length - 1 &&
        <S.IconButton onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const newArray = [...sectionState, generalHandler.events.createSectionRow({ questions })];

          if (['LIMITS'].includes(partySectionName)) {
            limitsHandler.events.handleLimitsChange({
              limits: newArray,
              setLimits: setSectionState,
              setFieldValue,
            });
          }
          setSectionState(newArray)
        }}>
          <Icon name="plus" style={{ margin: 0 }} />
        </S.IconButton>
      }
    </>
  )
}

const components = {
  renderSectionExtraButtons
}

export { components }